import React, { useEffect } from "react";
import { useFormFieldsMap } from "../../Pages/PositionForm/FormFieldsProvider";
import FieldTag from "../../Pages/Form/FieldTags/FieldTag";

const FormFieldPreview = ({ config, classes = "" }) => {
  const { formFieldMap, onElementInside } = useFormFieldsMap();
  const fieldId = config?.field?.id;
  const matchedField = formFieldMap?.[fieldId];

  const isMissing = !matchedField;
  useEffect(() => {
    onElementInside(fieldId);
    return () => onElementInside(fieldId, "delete");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div
      className={`${classes} h_100`}
      title={isMissing ? "Field not found" : ""}
      style={isMissing ? { border: "1px solid red" } : {}}
    >
      {isMissing ? <div>Field Not Found</div> : <FieldTag element={matchedField} />}
    </div>
  );
};

export default FormFieldPreview;
